import { useEffect, useRef, useState } from "react"
import { message } from "antd"
import { getStaffUserByMobile } from "~/api/staff"
import { UserLevelType } from "~/common/constants"
import { ApiRequestError } from "~/common/request"
import { isAbortError } from "~/common/utils"

export const getUserLevelCode = (user?: API.Staff.StaffUser | null) => {
  return user?.level_info?.level_code === UserLevelType.pro
    ? UserLevelType.pro
    : UserLevelType.free
}

// Staff 按手机号查询被操作用户；新查询会取消上一次未完成的请求
export const useStaffUserLookup = () => {
  const [queriedUser, setQueriedUser] = useState<API.Staff.StaffUser | null>(
    null,
  )
  const [queryingUser, setQueryingUser] = useState(false)
  const controllerRef = useRef<AbortController | null>(null)

  useEffect(() => () => controllerRef.current?.abort(), [])

  const lookupUser = async (mobile: string) => {
    const controller = new AbortController()
    controllerRef.current?.abort()
    controllerRef.current = controller
    setQueryingUser(true)

    try {
      const response = await getStaffUserByMobile(
        { mobile: mobile.trim() },
        controller.signal,
      )
      if (controller.signal.aborted) return

      const user = response.data?.user || null
      setQueriedUser(user?.id ? user : null)
      if (!user?.id) void message.warning("未找到有效用户")
    } catch (error) {
      if (isAbortError(error) || controller.signal.aborted) return

      setQueriedUser(null)
      // 业务错误已由请求层统一提示
      if (!(error instanceof ApiRequestError)) {
        void message.error("用户查询失败，请稍后重试")
      }
    } finally {
      if (controllerRef.current === controller) {
        controllerRef.current = null
        setQueryingUser(false)
      }
    }
  }

  const resetQueriedUser = () => {
    controllerRef.current?.abort()
    setQueriedUser(null)
  }

  return {
    queriedUser,
    queryingUser,
    lookupUser,
    resetQueriedUser,
    setQueriedUser,
  }
}
